import { FlaskConical, WifiOff } from 'lucide-react';
import { useOnline } from '../hooks/useOnline.ts';

export function DemoBanner() {
  return (
    <p className="banner banner--demo" role="note">
      <FlaskConical size={18} aria-hidden="true" />
      <span>
        <strong>Mode démonstration : données fictives.</strong> Les blocs marqués « Démo » ne reflètent pas la réalité :
        les sources officielles ne sont pas encore connectées.
      </span>
    </p>
  );
}

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <p className="banner banner--offline" role="status">
      <WifiOff size={18} aria-hidden="true" />
      <span>
        <strong>Hors ligne.</strong> Informations affichées à leur dernière mise à jour connue : elles peuvent être
        obsolètes.
      </span>
    </p>
  );
}
